import { Directive, HostListener, inject, Input } from '@angular/core';
import { COPY_TOKEN, CopyProvider } from '../tokens';

@Directive({
  standalone: true,
  selector: '[copyToClipboard]'
})
export class CopyValueToClipboardDirective {
  @Input('copyToClipboard') copyToClipboard!: string | null | undefined;

  private readonly copyProvider: CopyProvider = inject(COPY_TOKEN);

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.stopImmediatePropagation();

    this.copyProvider.copyToClipboard(this.copyToClipboard ?? '').subscribe();
  }
}
